import { css } from '@emotion/react';
import { addParamsToUrl } from '@zapier/url-utils';

import { Link, Typography } from '@zapier/design-system';
import { urls, useSize } from '@zapier/identity-utils';
import { useTranslations } from 'next-intl';

import {
  AuthLayout,
  CompaniesIntroPromo,
} from '@zapier/auth-pages/src/components/global';

const textStyle = css`
  ${Typography.Body1}
  text-align: center;
`;

const rootStyle = css`
  display: grid;
  gap: 20px;
  padding: 40px 0;
`;

export function ActivateAccountPage() {
  const size = useSize();
  const t = useTranslations('activate-account');
  const titleText = 'Thanks for signing up';

  function HelpLink(chunks: React.ReactNode) {
    return (
      <Link
        href={addParamsToUrl(urls.HELP_URL, {
          account: 'other',
          topic: 'account',
        })}
      >
        {chunks}
      </Link>
    );
  }

  return (
    <AuthLayout
      promo={<CompaniesIntroPromo />}
      showPromo={size !== 'small'}
      title={titleText}
      titlePosition={'right'}
    >
      <section css={rootStyle}>
        <p css={textStyle}>{t('greeting')}</p>
        <p css={textStyle}>{t('description')}</p>
        <p css={textStyle}>{t.rich('link-help', { link: HelpLink })}</p>
      </section>
    </AuthLayout>
  );
}
